(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('error', ['$timeout', function ($timeout) {
			return {
				restrict: 'C',
				link: function (scope, element, attrs) {
					if (element.hasClass('no-link')) return;
					//get parent input field
					var inputElement = $(element).prevAll('input:first')[0];
					if (!inputElement) {
						inputElement = $(element).prevAll('select:first')[0];
					}

					element.on('click', function (event) {
						inputElement.focus();
					});
					element.on('keydown keypress', function (event) {
						var key = event.keyCode || event.which;
						if (key === 13) {
							inputElement.focus();
						}
					});
					//Add a11y string based on error type
					var a11yString = ""
					if (scope.$root.glContent)
						a11yString = scope.$root.glContent.errors.error;
					var classes = element[0].classList;
					var offscreen = document.createElement('SPAN');
					offscreen.classList.add('off-screen');
					if (scope.$root.glContent && classes.contains('error-required')) {
						a11yString = a11yString + scope.$root.glContent.errors.error_required;
					} else if (scope.$root.glContent && classes.contains('error-invalid')) {
						a11yString = a11yString + scope.$root.glContent.errors.error_invalid;
					}
					offscreen.innerHTML = a11yString;
					element[0].insertBefore(offscreen, element[0].childNodes[0]);
					element[0].setAttribute("aria-describedby", 'errMsgHelper');
					//Don't use aria-hidden in mobile. Causes issues with talkback (Android a11y)
					if (window.innerWidth > 768) {
						element[0].setAttribute("aria-hidden", 'true');
						//Change aria-hidden attribute. angular watch visibility not reliable enough, using input element on blur instead
						inputElement && inputElement.addEventListener('blur', function (event) {
							$timeout(function () {
								if ($(element).is(':visible')) {
									element[0].setAttribute("aria-live", "assertive");
								} else {
									element[0].removeAttribute("aria-live");
								}
								element[0].setAttribute("aria-hidden", $(element).is(':visible') ? 'false' : 'true');
							})
						})
					}
				}
			}
		}]);
})();
